import React from 'react'
import './CompletedQ.css'
import { Col, Row } from 'react-bootstrap'
import BorderedSec from '../../UI/BorderedSec'
import Card from '../../UI/Card/Card'
import SecBTN from '../../UI/SecBTN'

const CompletedQ = props => {
  //let questions = props.question
  //let hindiQuestions = props.hindiQuestion
  //let options = props.engOption.split("@@@")
  //let newOptions = [...new Set(options)];
  //let hindiOptions = props.hindiOption.split("@@@")
  //let hindiNewOptions = [...new Set(hindiOptions)];
  //let solutions = props.answer
  //let hindiSolutions = props.hindiAnswer;
  return (
    <React.Fragment>
      <Col lg={props.lgGrid ? 6 : 12} style={{pageBreakInside:"avoid"}}>
        <BorderedSec>
          <Card>
            <Row>
              {/* <Col lg={8} md={8} sm={7}>
                <p className="completed-ques__text1">
                  Q{props.qNo}. {props.qType}
                </p>
              </Col>
              <Col lg={4} md={4} sm={5}>
                <div className="sec-editable">
                  <SecBTN
                    type="button"
                    className="cmplte-btn"
                    onClick={props.changeQHandler}
                  >
                    Change Ques
                  </SecBTN>
                  <i className="bx bxs-edit" onClick={props.editQHandler}></i>
                </div>
              </Col> */}
              <Col lg={3} md={6} sm={6}>
                <Card className="sec-card">
                  <b>Qid :</b> {props?.qid}
                </Card>
              </Col>
              <Col lg={3} md={6} sm={6}>
                <Card className="sec-card">
                  <b>topic :</b> {props?.topic}
                </Card>
              </Col>
              <Col lg={3} md={6} sm={6}>
                <Card className="sec-card">
                  <b>Sub-topic :</b> {props?.subTopic}
                </Card>
              </Col>
              <Col lg={3} md={6} sm={6}>
                <Card className="sec-card">
                  <b>Toughness :</b> {props?.toughness}
                </Card>
              </Col>
            </Row>
          </Card>
          <Row>
            <Col lg={6} md={6} sm={6}>
              <Card className="sec-card1">
                <b>Question {props.qNo} : </b>
                <div dangerouslySetInnerHTML={{ __html: props?.question }} />
                <ol
                  style={{
                    listStyleType: "upper-alpha",
                    marginLeft: "30px",
                  }}
                >
                  { props.engOption !== null ?
                    [...new Set(props?.engOption?.split("@@@"))]?.map((data, i) => {
                    return (
                      <li key={i}>
                        {" "}
                        <div dangerouslySetInnerHTML={{ __html: data }} />
                      </li>
                    );
                  }) : ""}
                </ol>
              </Card>
            </Col>
            <Col lg={6} md={6} sm={6}>
              <Card className="sec-card1">
                <b>प्रश्न : </b>
                <div dangerouslySetInnerHTML={{ __html: props?.hindiQuestion }} />
                <ol
                  style={{
                    listStyleType: "upper-alpha",
                    marginLeft: "30px",
                  }}
                >
                  { props.hindiOption !== null ?
                    [...new Set(props?.hindiOption?.split("@@@"))]?.map((data, i) => {
                    return (
                      <li key={i}>
                        {" "}
                        <div dangerouslySetInnerHTML={{ __html: data }} />
                      </li>
                    );
                  }) : ""}
                </ol>
              </Card>
            </Col>
          </Row>
          <p className="crct-ans-opt">
            Answer : <span>{props.correctAns}</span>
          </p>
          <Row>
            <Col lg={6} md={12} sm={12}>
              <Card className="sec-card1">
                {/* <b>Answer : {props.answer}</b> */}
                <div dangerouslySetInnerHTML={{ __html: props?.answer }} />
              </Card>
            </Col>
            <Col lg={6} md={12} sm={12}>
              <Card className="sec-card1">
                {/* <b>Answer : {props.answer}</b> */}
                <div dangerouslySetInnerHTML={{ __html: props?.hindiAnswer }} />
              </Card>
            </Col>
          </Row>
        </BorderedSec>
      </Col>
    </React.Fragment>
  );
}

export default CompletedQ
